/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1EmployeepostEmployeepostidClassStudents200,
  GetApiV1EmployeepostEmployeepostidClassStudents401,
  GetApiV1EmployeepostEmployeepostidClassStudents404,
  GetApiV1EmployeepostEmployeepostidClassStudents500,
  GetApiV1EmployeepostEmployeepostidClassStudentsPathParams,
  GetApiV1EmployeepostEmployeepostidClassStudentsQueryParams,
  GetApiV1EmployeepostEmployeepostidClassStudentsQueryResponse,
} from "../../types/employeePostController/GetApiV1EmployeepostEmployeepostidClassStudents.ts";
import { employeePostClassStudentViewModelPaginatedResponseSchema } from "../employeePostClassStudentViewModelPaginatedResponseSchema.ts";

export const getApiV1EmployeepostEmployeepostidClassStudentsPathParamsSchema =
  z.object({
    employeePostId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudentsPathParams>;

export const getApiV1EmployeepostEmployeepostidClassStudentsQueryParamsSchema =
  z.object({
    page: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1EmployeepostEmployeepostidClassStudents200Schema = z.lazy(
  () => employeePostClassStudentViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1EmployeepostEmployeepostidClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1EmployeepostEmployeepostidClassStudents404Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudents404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1EmployeepostEmployeepostidClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudents500>;

export const getApiV1EmployeepostEmployeepostidClassStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1EmployeepostEmployeepostidClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1EmployeepostEmployeepostidClassStudentsQueryResponse>;
